import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d171a70"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border text-primary spinner-border-sm" }, null, -1))
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = { class: "dropdown border rounded" }
const _hoisted_6 = ["disabled", "placeholder"]
const _hoisted_7 = { class: "dropdown-menu" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["value", "onClick"]
const _hoisted_10 = { class: "dropdown-item" }
const _hoisted_11 = ["for"]
const _hoisted_12 = { class: "invalid-feedback" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading && _ctx.ready)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass([(_ctx.compact) ? '': 'form-floating', "mb-3"])
        }, [
          _createElementVNode("span", {
            type: "text",
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.errors, 'disabled': _ctx.readonly}]),
            id: _ctx.id
          }, [
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_ctx.options[0]), 1)
          ], 10, _hoisted_1),
          (_ctx.showLabel)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _ctx.id,
                class: "form-label"
              }, _toDisplayString(_ctx.label), 9, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.errorMessage), 1)
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.loading || !_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([(_ctx.compact) ? '': 'form-floating', "mb-3"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("select", {
              class: "dropdown-toggle form-select",
              "data-bs-toggle": "dropdown",
              "aria-expanded": "false",
              readonly: true,
              disabled: _ctx.readonly,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.t && _ctx.t(...args))),
              placeholder: _ctx.label
            }, [
              _createElementVNode("option", null, _toDisplayString(_ctx.getOptionName(_ctx.modelValue)), 1)
            ], 8, _hoisted_6),
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    placeholder: "Filtrer",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.filter]
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (name, optionId) => {
                return (_openBlock(), _createElementBlock("li", {
                  value: optionId,
                  key: optionId,
                  onClick: ($event: any) => (_ctx.handleInput(optionId))
                }, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getName(name)), 1)
                ], 8, _hoisted_9))
              }), 128))
            ])
          ]),
          (_ctx.showLabel)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: _ctx.id
              }, _toDisplayString(_ctx.label), 9, _hoisted_11))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.errorMessage), 1)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}